import { View } from '@react-pdf/renderer'
import { useMemo } from 'react'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'
import { ReportsType } from '@features/reports/enums/reportsType'
import {
  mapBalanceSheetBalances,
  mapProfitAndLossBalances,
  mapTrialBalanceBalances,
} from '@features/reports/utils/balanceMappers'
import { buildTableData } from '@features/reports/utils/buildTableData'

import { useReportsPdfDocument } from '../../contexts/reportsPdfDocumentContext'
import { BalanceSheetBalanceCell, ProfitAndLossBalanceCell, TrialBalanceBalanceCell } from './elements/BalanceCells'
import { ReportsPdfTableHeaderRow } from './elements/ReportsPdfTableHeaderRow'
import { TableRowsRenderer } from './elements/TableRowsRenderer'
import { headersToFooters } from './utils/headersToFooter'

export const ReportsPdfTable = () => {
  const { reportData, expandedRows, reportType, periods } = useReportsPdfDocument()

  const tableContent = useMemo(() => {
    switch (reportType) {
      case ReportsType.BalanceSheet: {
        const data = buildTableData(reportData, expandedRows, periods, mapBalanceSheetBalances)
        const sorted = headersToFooters(data)
        return <TableRowsRenderer rows={sorted} BalanceCell={BalanceSheetBalanceCell} reportType={reportType} />
      }
      case ReportsType.ProfitAndLoss: {
        const data = buildTableData(reportData, expandedRows, periods, mapProfitAndLossBalances)
        const sorted = headersToFooters(data)
        return <TableRowsRenderer rows={sorted} BalanceCell={ProfitAndLossBalanceCell} reportType={reportType} />
      }
      case ReportsType.TrialBalance: {
        const data = buildTableData(reportData, expandedRows, [], mapTrialBalanceBalances)
        const sorted = headersToFooters(data)
        return <TableRowsRenderer rows={sorted} BalanceCell={TrialBalanceBalanceCell} reportType={reportType} />
      }
      default:
        return null
    }
  }, [reportType, reportData, expandedRows, periods])

  return (
    <View style={commonPdfTableStyles.wrapper}>
      <ReportsPdfTableHeaderRow />
      {tableContent}
    </View>
  )
}
